module.exports = __webpack_public_path__ + "static/img/google.8bba39fd.png";